<!-- 工控-产品库存管理 -->
<template>
  <el-card>
    <div class="toolbar">
      <el-button type="success" @click="onPrint()">
        <i class="fa fa-print"></i> 打印设备交接单
      </el-button>
      <div class="former">
        <select2
          labelName="NameNumber"
          v-model="former.IpcProductModelID"
          url="ipc/model/product/list?order=name"
          clearable
          placeholder="选择产品型号"
          no-data-text="没有产品型号"
          :urlParams="{
            where: {},
          }"
          q="NameNumber:like"
          :qinwhere="true"
          :queryOne="false"
          style="width: 300px"
        ></select2
        >&nbsp;
        <el-input
          v-model.trim="key"
          placeholder="产品SN/机器码"
          @keydown.enter.native="onSubmitQuery"
          style="width: 300px"
        >
        </el-input
        >&nbsp;
        <select2
          labelName="ClientName"
          v-model="former.ClientID"
          url="client/list"
          clearable
          placeholder="选择客户"
          no-data-text="没有客户"
          :urlParams="{
            where: {},
          }"
          q="ClientName:like"
          :qinwhere="true"
          :queryOne="false"
        ></select2
        >&nbsp;
        <el-select
          v-model="contractNos"
          collapse-tags
          placeholder="选择合同编号"
          filterable
          clearable
          style="width: 180px"
        >
          <el-option
            v-for="(contractNo, index) in contractNoList"
            :key="index"
            :label="contractNo"
            :value="contractNo"
          ></el-option> </el-select
        >&nbsp;
        <select2
          labelName="Value"
          valueKey="Key"
          v-model="former.Status"
          url="ipc/product/stock-status-list"
          clearable
          placeholder="请选择状态"
          no-data-text="没有状态"
          style="width: 120px"
        ></select2
        >&nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>
    <el-table
      :data="itemList"
      v-loading="loading"
      size="medium"
      @selection-change="onSelectChanged"
      :row-key="getRowKey"
    >
      <el-table-column type="selection" width="45" :reserve-selection="true">
      </el-table-column>
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * pager.page).toString().length * 12)"
      />
      <el-table-column prop="Name" label="站点名称"
        ><template slot-scope="scope">
          <div v-if="scope.row.Station">
          <el-link type="primary">
            <a
              target="_self"
              class="buttonText"
              @click="showStaton(scope.row)"
              >{{ scope.row.Station.Name }}</a
            >
          </el-link>
          </div>
          <div v-else>——</div>
        </template></el-table-column
      >
      <el-table-column prop="IpcProductModel.Name" label="产品型号名称/产品型号" width="220" >
      <template slot-scope="{ row }">
          <div v-if="row.IpcProductModel">
            {{ row.IpcProductModel.Name }}
          </div>
          <div style="padding-top: 5px" v-if="row.IpcProductModel">
            {{ row.IpcProductModel.Number }}
          </div>
        </template></el-table-column>
      <el-table-column prop="MachineCode" label="产品SN/机器码" width="350">
        <template slot-scope="{ row }">
          <div>
            <el-tag>{{ row.SN }}</el-tag>
          </div>
          <div style="padding-top: 3px">
            <el-tag type="success">
              {{ row.MachineCode }}
            </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="合同编号" width="170">
        <template slot-scope="{ row }">
          <el-tag
            v-for="contractNo in row.ContractNos"
            :key="contractNo"
            style="margin-right: 5px; color: #00b3ca"
            >{{ contractNo }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="Client.ClientName" label="客户" width="180" />
      <el-table-column prop="IsQuality" label="是否在保" width="80">
        <template slot-scope="{ row }">
          <el-tag v-if="row.IsQuality === '否'" type="warning"> 过保 </el-tag>
          <el-tag v-else-if="row.IsQuality === '是'" type="success">
            在保
          </el-tag>
          <el-tag v-else> {{ row.IsQuality }} </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="StatusName" label="状态" width="80">
        <template slot-scope="{ row }">
          <el-tag v-if="row.Status === 1" type="warning">
            {{ row.StatusName }}
          </el-tag>
          <el-tag v-else type="success">
            {{ row.StatusName }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column width="100" label="操作">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.Status === 1"
            type="primary"
            @click.stop="onOutItem(scope.row)"
            title="出库"
          >
            <i class="fas fa-sign-in-alt"></i>
          </el-button>
          <el-button
            v-else
            type="primary"
            @click.stop="onEditItem(scope.row)"
            title="编辑"
          >
            <i class="fas fa-pencil-alt"></i>
          </el-button>
          <el-button
            type="danger"
            @click.stop="onDeleteClick(scope.row)"
            title="删除"
            v-permission="'ipc_product_stock-DELETE'"
          >
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      >
      </el-pagination>
    </div>

    <out v-model="item" :visible.sync="outVisible" @form:saved="getItemList" />
    <edit
      v-model="item"
      :visible.sync="editVisible"
      @form:saved="getItemList"
    />
    
    <el-dialog
      title="站点信息"
      :visible.sync="showVisible"
      @close="showVisible = false"
      width="80%"
      top="5%"
      append-to-body
      :close-on-click-modal="false"
      ><show-station :ID="statonID" :showBack="false" :key="statonID" />
    </el-dialog>
  </el-card>
</template>

<script>
import Out from "./out.vue";
import Edit from "./edit.vue";
import ShowStation from "../../pn/station/index--detail.vue";

export default {
  components: {
    Out,
    Edit,
    ShowStation,
  },
  data() {
    return {
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 10,
      },
      former: {
        IpcProductModelID: "",
        Status: "",
        ClientID: "",
      },
      key: "",
      contractNos: [],
      item: this.getEmptyItem(),

      outVisible: false,
      editVisible: false,
      proIds: [],
      contractNoList: [],
      showVisible: false,
      statonID:"",
    };
  },
  created() {
    this.getContractNoList();
    this.getItemList();
  },
  methods: {
    getItemList() {
      this.loading = true;
      this.$axios
        .get("ipc/product/stock-list", {
          params: {
            where: this.former,
            key: this.key,
            contractNos: this.contractNos,
            ...this.pager,
            with: [
              "RecipientDept",
              "Client",
              "IpcProductModel",
              "IpcAccessories.IpcAccessoryModel",
            ],
            order: ["-stockin_at", "-sn"],
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getContractNoList() {
      this.$axios
        .get("ipc/product/stock-contractNos")
        .then((response) => {
          this.contractNoList = response.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    onDeleteClick(row) {
      this.$confirm("确定要删除此产品吗？", "提示")
        .then(() => this.$axios.delete(`ipc/product/stock-delete/${row.ID}`))
        .then(() => {
          this.getItemList();
          this.$message.success("删除成功");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    onOutItem(row) {
      this.item = row;
      this.outVisible = true;
    },
    onEditItem(row) {
      this.item = row;
      this.editVisible = true;
    },
    getEmptyItem() {
      return {};
    },
    showStaton(row) {
      this.statonID = row.Station.ID;
      this.showVisible = true;
    },
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    onPrint() {
      if (this.proIds.length > 0) {
        this.$axios
          .request({
            url: "ipc/product/stock-out/print",
            method: "post",
            responseType: "blob",
            data: {
              ids: this.proIds,
            },
          })
          .then((res) => {
            this.autoDownloadBlobFile(
              new window.Blob([res.data], { type: "application/vnd.ms-excel" }),
              "设备交接单.xlsx"
            );
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.$message.warning("请至少选择一个配件!");
        return;
      }
    },
    onSelectChanged(options) {
      this.proIds = options.map((x) => x.ID);
    },
    getRowKey(row) {
      return row.ID;
    },
  },
};
</script>
